<template>
  <div class="layer" :class="{qrOnly: qrOnly}">
    <div class="inner">
      <button type="button" class="btnClose" @click.stop="cancel"><span class="blind">close</span></button>
      <div v-if="!qrOnly" class="mb15">
        <div class="layerTitle toCapitalize">{{locale.mobility_request_result_success}}</div>
        <div class="mb15">{{ locale.message_mobility_request_result_success_1 }}</div>
        <div class="cf mb15">{{locale.message_mobility_request_result_success_2}}</div>
        <p>{{locale.message_mobility_request_result_success_3}}</p>
      </div>
      <div v-if="isPublic" class="qrInfo">
        <p>{{locale.mobility_my_qrcode}}</p>
        <div class="qrBg">
          <div v-if="qrCode === 'fail'" class="noQr"><img src="@/assets/img/img_qr_fail.png" alt=""></div>
          <vue-qrcode
            v-else-if="qrCode"
            :value="qrCode"
            :scale="6" />
        </div>
        <div v-if="qrCode === 'fail'" class="failMessage">{{locale.qr_create_fail}}<br>{{locale.refresh_retry}}</div>
      </div>
      <div v-if="!isPublic" class="btns">
        <!-- <button type="button" class="btn btnWhite toCapitalize" @click.stop="cancel">{{locale.close}}</button> -->
        <router-link
          :to="{ name: 'myMobility' }"
          class="btn btnWhite toCapitalize">
          {{locale.mobility_my}}
        </router-link>
        <button type="button" class="btn toCapitalize" @click.stop="viewDetail">
          {{locale.mobility_my_realtime}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VueQrcode from 'vue-qrcode'

export default {
  name: 'MobilityResult',
  props: [
    'locale',
    'lang',
    'isPublic',
    'qrOnly', // qrcode 스캔용?
    'resultData'
  ],
  components: {
    VueQrcode
  },
  computed: {
    siteinfo () {
      return this.$store.state.authentication
    }
  },
  mounted () {
    this.$nextTick(() => {
      const siteinfo = this.siteinfo
      const win = window.location
      let params = publicToOta(win.search)
      let url = ''
      // 공용디바이스 사용자는 개인링크로 변환 params
      function publicToOta (queryString) {
        const params = {}
        queryString.replace(/[#?&]+([^=&]+)=([^&]*)/gi, function (str, key, value) {
          params[key] = value
        })
        params.frame = false
        return params
      }
      if (this.isPublic) {
        delete params.public
        params.k = siteinfo.k
        params = Object.entries(params).map(e => e.join('=')).join('&')
        url = `${win.origin}${win.pathname}?${params}#/${this.lang}/mobility/my`
        this.$store.dispatch('util/getShortUrl', {
          url: url,
          days: 1
        }).then((res) => {
          if (res) {
            this.qrCode = res
          } else {
            this.qrCode = 'fail'
          }
        })
      }
    })
  },
  data () {
    return {
      qrCode: null
    }
  },
  methods: {
    viewDetail () {
      window.open(this.resultData.webUrl)
      setTimeout(() => {
        this.$router.push({
          name: 'myMobility'
        })
      }, 300)
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  & > .inner {
    max-width: 480px;
  }
  .btns {
    .btn {
      padding-left: 0;
      padding-right: 0;
    }
  }
}
.qrInfo {
  margin-top: 30px;
  text-align: center;
  font-size: 20px;
}
.qrBg {
  height: 200px;
  margin-bottom: 15px;
  background: url('~@/assets/img/img_qr_loading.png') 50% 50% / contain no-repeat;
  img {
    max-height: 100%;
  }
}
.noQr {
  height: 100%;
  background-color: $color-white;
}
.failMessage {
  font-size: 14px;
  color: $color-red;
}
.cf {
  font-size: 14px;
  color: $color-grey;
}
@media screen and (min-width: 768px) {
  .layer {
    & > .inner {
      padding: 30px;
    }
  }
}
</style>
